import { registerMockAPI } from '~/mocks/mockApis';

import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { RECEIVE } from '~/constants/errorCode';

import type {
  TypeApiResponse,
  TypePostReceivingRequestParams,
  TypePostReceivingRequestResponse,
} from '~/types/receive.types';

type TypePostReceivingRequestMutationParams = {
  ownerCode: string;
  params: TypePostReceivingRequestParams;
};

const fetchPostReceivingRequest = async ({
  ownerCode,
  params,
}: TypePostReceivingRequestMutationParams): Promise<TypePostReceivingRequestResponse> => {
  const { data } = await axiosInstance.post<TypeApiResponse<TypePostReceivingRequestResponse>>(
    `/api-inbound/v1/3pl/receiving/${ownerCode}/request`,
    params
  );

  return data.data;
};

/**
 * [입고관리 > 입고요청관리] 입고요청등록 모달 > 입고 요청 Mutation Hook
 */
export const usePostReceivingRequestMutation = () => {
  return useMutation({
    mutationFn: fetchPostReceivingRequest,
  });
};

const normalResponse: TypeApiResponse<TypePostReceivingRequestResponse> = {
  data: {
    requestedOrders: [
      {
        id: 1001,
        inboundAreaId: 5001,
        inboundAreaAddress: '경기도 김포시 김포한강9로 76',
        skuCount: 2,
        unitSum: 30,
        items: [
          {
            itemId: 10001,
            goodsCode: 'EN0000010151',
            goodsName: '닥터유 단백질 35g(3PL)',
            unit: 12,
            nsid: 'NSID-0000010151',
          },
          {
            itemId: 10002,
            goodsCode: 'EN0000010152',
            goodsName: '닥터유 단백질 40g(3PL)',
            unit: 18,
            nsid: 'NSID-0000010152',
          },
        ],
      },
    ],
  },
};

registerMockAPI<TypeApiResponse<TypePostReceivingRequestResponse>>({
  method: 'post',
  endpoint: '/api-inbound/v1/3pl/receiving/:ownerCode/request',
  label: '입고/입고요청/요청등록',
  scenarios: [
    { name: '정상 응답', response: normalResponse },
    {
      name: '입고일시 불가 (9030)',
      response: {
        error: {
          code: RECEIVE.RECEIVE_DATE_TIME_NOT_EXIST,
          message: '선택한 입고일시에 입고 요청이 불가능합니다. 다른 일시를 선택해 주세요.',
          values: [1001],
        },
      },
      status: 400,
    },
    {
      name: '잘못된 파라미터 (9001)',
      response: {
        error: {
          code: 9001,
          message: '입고 요청 등록에 실패했습니다.\n다시 시도해주세요.',
        },
      },
      status: 400,
    },
  ],
});
